import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateConditions'
})

export class TranslateCondidtionsPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        let output: string;

        switch (value) {
            case 'Aktenplanverwaltung':
                output = 'Structure';
                break;
            case 'VorgangsVerwaltung':
                output = 'Folder';
                break;
            case 'Schriftgutverwaltung':
                output = 'Document';
                break;
            case 'Sitzungsverwaltung':
                output = 'Meeting';
                break;
            case 'Adressverwaltung':
                output = 'Address';
                break;
        }
        return output;
    }

    seticon(value: any, args?: any): any {
        let iconclass: string;

        switch (value) {
            case 'Aktenplanverwaltung':
                iconclass = 'fa-folder';
                break;
            case 'VorgangsVerwaltung':
                iconclass = 'fa-folder-open';
                break;
            case 'Schriftgutverwaltung':
                iconclass = 'fa-file-text';
                break;
            case 'Sitzungsverwaltung':
                iconclass = 'fa-users';
                break;
            case 'Adressverwaltung':
                iconclass = 'fa-address-card';
                break;
        }
        return iconclass;
    }
}



// WEBPACK FOOTER //
// ./src/shared/translate-conditions.pipe.ts